import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** shadcn/ui class-name helper. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=class-names.js.map